export default function truncate(string, truncateLen) {
  return (string && (string.length > truncateLen))
    ? `${string.slice(0, truncateLen)} ...` : string;
}
